import c from './card.module.scss';
import React from 'react';

const Card = ({ children, columnNos = 1, ...restProps }) => {
  return (
    <div
      className={c.card}
      style={{ gridTemplateColumns: `repeat(${columnNos}, 1fr )` }}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default Card;
